module.exports = __webpack_public_path__ + "img/ls.61a69eba.svg";